import { Music, ConciergeBell, Wine, Flower2, Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = { "fado-ao-vivo": Music, gastronomia: ConciergeBell, vinhos: Wine, cultura: Flower2, ambiente: Users };

export const Pillars = () => {
    const { t } = useLanguage();
    return (
        <section className="relative z-10" data-testid="pillars-section">
            <div className="mx-auto max-w-[1500px] px-5 sm:px-10 py-12 sm:py-14">
                <div className="flex justify-center mb-10">
                    <img loading="lazy" decoding="async" src="/images/ornamento.webp" alt="" aria-hidden="true" className="w-32 opacity-80" data-testid="pillars-flourish" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-0 lg:divide-x lg:divide-[#c9a24b]/45">
                    {t.pillars.map((p, i) => {
                        const Icon = ICONS[p.id];
                        return (
                            <Reveal key={p.id} delay={i * 0.1} className="lg:px-8 text-center">
                                <div className="flex justify-center">
                                    <Icon size={46} strokeWidth={1.3} className="text-[#d19a3f]" data-testid={`pillar-icon-${p.id}`} />
                                </div>
                                <h3 className="font-caps text-base sm:text-lg tracking-[0.12em] uppercase text-[#d19a3f] mt-6 leading-relaxed">{p.title}</h3>
                                <p className="font-display text-lg sm:text-xl text-[#efe6d6]/90 font-light mt-4 leading-relaxed max-w-[250px] mx-auto">{p.text}</p>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
